// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Bond } from './bond';
import { Counterparty } from './counterparty';
import { RateType } from './rate-type';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Insurer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  insurerId!: number;
  counterpartyId!: number;
  createdBy!: string;
  createdDate!: Date;
  discountRateTypeId?: number;
  enablingBondRateTypeId?: number;
  specificPenaltyRateTypeId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  bonds!: Bond[];
  counterparty!: Counterparty;
  discountRateType!: RateType;
  enablingBondRateType!: RateType;
  specificPenaltyRateType!: RateType;
  users!: User[];
}

